import type { FC, ReactNode } from 'react'

import { Fragment } from 'react'

import { Button } from '@/components/generals/button'
import { ctaFeatures } from '@/constants/content'

export const Cta: FC = (): ReactNode => {
    return (
        <section className='cta-section padding-bottom'>
            <div className='w-layout-blockcontainer container cta w-container'>
                <div className='cta-content-wrapper' data-reveal>
                    <div className='cta-title-wrapper'>
                        <h2 className='cta-title'>
                            Ready to transform your space?
                        </h2>

                        <p className='cta-subtitle'>
                            Contact us today for a free, no-obligation estimate. We would love to
                            hear about your project.
                        </p>
                    </div>

                    <Button href='/book-free-consultation' label='Get Free Estimate' variant='style-02' />
                </div>

                <div className='cta-bottom'>
                    {ctaFeatures.map((feature, index) => (
                        <Fragment key={feature}>
                            {index > 0 && <div className='cta-feature-divider' />}

                            <p className='cta-feature'>
                                {feature}
                            </p>
                        </Fragment>
                    ))}
                </div>
            </div>
        </section>
    )
}
